import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { AfTranslateDirective } from '../../../shared/modules/translate/directive/af-translate.directive';
import { FieldTypeNumberComponent } from '../../../shared/components/field-type-number/field-type-number.component';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { CustomizeFieldsSwitchFormComponent } from "../customize-fields-switch-form/customize-fields-switch-form.component";
import { FieldTypeSwitchComponent } from "../../../shared/components/field-type-switch/field-type-switch.component";

@Component({
    selector: 'customize-field-bool',
    templateUrl: './customize-field-bool.component.html',
    standalone: true,
    imports: [NgClass, AfTranslateDirective, FormsModule, FieldTypeNumberComponent, CustomizeFieldsSwitchFormComponent, FieldTypeSwitchComponent]
})
export class CustomizeFieldBoolComponent implements OnChanges {
  customizeFieldBool: any = {
    codeColor: { label: this.translate.instant('customize.code-color') },
    weightYesInfo: {
      label: this.translate.instant('customize-field-bool.weight-yes'),
      fieldTypeId: 'num',
      required: true
    },
    weightNoInfo: {
      label: this.translate.instant('customize-field-bool.weight-no'),
      fieldTypeId: 'num',
      required: true
    }
  }
  constructor(private translate: AfTranslateFactory) { }
  @Input() field:any = null;
  @Input() isPrivate:any = null;
  @Input() hiddenInLandings: boolean = false;
  @Input() concept:any = null;
  @Input() previewMode: boolean = false;
  @Input() actionType: string = 'edit';

  ngOnChanges(changes: SimpleChanges): void {
    let that: any = this.customizeFieldBool;
    if(changes['field'] && changes['field'].currentValue){
      that.field = changes['field'].currentValue;
      that.color = that.field.withColor >= 1;
      if(that.field.fieldTypeId === 'boolp'){
          that.weightYesInfo.noEditable = that.field.noEditable || this.previewMode;
          that.weightNoInfo.noEditable = that.field.noEditable || this.previewMode;
      }
    }
  }

  itemSelected(e:any, type:any){
    let that: any = this.customizeFieldBool;
    switch(type){
      case 'color':
        that.field[type] = e.newValue;
        that.field.withColor = that.field.color?1:0;
        break;
      case 'withColor':
        this.customizeFieldBool.field.withColor = this.customizeFieldBool.field.withColor === 1? 2 : 1;
        break;
      case 'weightYes':
        that.field[type] = e.newValue;
        that.weightYesInfo.error = false;
        break;
      case 'weightNo':
        that.field[type] = e.newValue;
        that.weightNoInfo.error = false;
        break;
      default:
        that.field[type] = e.newValue;
        break;
    }
  }

  validateSave(){
    if(!Number.isInteger(this.customizeFieldBool.field.weightYes)){
        this.customizeFieldBool.weightYesInfo.error = true;
    }
    if(!Number.isInteger(this.customizeFieldBool.field.weightNo)){
        this.customizeFieldBool.weightNoInfo.error = true;
    }
    return this.customizeFieldBool.weightYesInfo.error || this.customizeFieldBool.weightNoInfo.error?false:true;
  }
}
